import axios from 'axios'
import { BASEURL } from './api.variables'

const IMAGESPLACESURL = (limit, skip, language, placeId) => {
  let params = ''
  if (limit) {
    params += `limit=${limit}`
  }
  if (skip) {
    params += `&skip=${skip}`
  }
  if (language) {
    params += `&language=${language}`
  }
  return `${BASEURL}/places/${placeId}/images?${params}`
}
const IMAGECOVERURL = (placeId, imageId) => `${BASEURL}/places/${placeId}/images/${imageId}/setcover`
const IMAGEDELETEURL = (placeId, imageId) => `${BASEURL}/places/${placeId}/images/${imageId}`

const headers = () => {
  return {
    Authorization: document.redecienciaToken ? `Bearer ${document.redecienciaToken}` : ''
  }
}

const SetCoverImage = (placeId, imageId) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: IMAGECOVERURL(placeId, imageId),
      headers: headers()
    })
      .then(
        success => {
          resolve(success)
        },
        error => {
          reject(error)
          if (error.response.status === 403 || error.response.status === 401) {
            window.location.href = '/403'
          }
        }
      )
  })
}

const bulkUpload = (arrayData, placeId) => {
  let arrayRequests = []
  arrayData.forEach(item => {
    arrayRequests.push(
      axios({
        method: 'post',
        url: IMAGESPLACESURL(null, null, null, placeId),
        headers: headers(),
        data: item
      })
    )
  })
  return new Promise((resolve, reject) => {
    axios.all(arrayRequests)
      .then(
        axios.spread(function () {
          let files = []
          for (let i = 0; i < arguments.length; i++) {
            files.push(arguments[i].data)
          }
          resolve(files)
        }),
        error => {
          reject(error)
          if (error.response.status === 403 || error.response.status === 401) {
            window.location.href = '/403'
          }
        }
      )
  })
}

const DeleteImage = (placeId, imageId) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'delete',
      url: IMAGEDELETEURL(placeId, imageId),
      headers: headers()
    })
      .then(
        success => {
          resolve(success)
        },
        error => {
          reject(error)
          if (error.response.status === 403 || error.response.status === 401) {
            window.location.href = '/403'
          }
        }
      )
  })
}

const GetImages = (limit = 50, skip = 0, language = 'pt', placeId) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: IMAGESPLACESURL(limit, skip, language, placeId),
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

export {
  bulkUpload,
  SetCoverImage,
  DeleteImage,
  GetImages
}



// WEBPACK FOOTER //
// ./src/api/images.js